require("style-loader!css-loader!less-loader!./font-awesome-styles.loader.js!./font-awesome.config.js");



//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-webpack/index.js
// module id = 283
// module chunks = 0